import { useQuery } from 'react-query';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../../../CommonUtils/urlWithParams';
import { SocialSecurityStrategy } from './types';
import { queryKeys } from './queryKeys';

export type { SocialSecurityStrategy } from './types';

export interface AnnualBenefitsSummaryDTO {
  Years: number[];

  PrincipalName: string | null;
  PrincipalAges: number[] | null;
  PrincipalBenefits: number[] | null;

  SpouseName: string | null;
  SpouseAges: number[] | null;
  SpouseBenefits: number[] | null;
}

const BASE_URL = '/Consumer/OptimizeSocialSecurity/GetAnnualBenefitsSummary';

const fetchAnnualBenefitsSummary = async (
  clientId: number,
  fpId: string,
  strategy: SocialSecurityStrategy,
): Promise<AnnualBenefitsSummaryDTO> => {
  return authFetch(urlWithParams(BASE_URL, { clientId, fpId, strategy }));
};

export interface Params {
  clientId: number;
  fpId: string;
  strategy: SocialSecurityStrategy;
  enabled: boolean;
}

export const useAnnualBenefitsSummaryQuery = ({ clientId, fpId, strategy, enabled }: Params) => {
  return useQuery(
    queryKeys.annualBenefitsSummary(clientId, fpId, strategy),
    () => fetchAnnualBenefitsSummary(clientId, fpId, strategy),
    { enabled },
  );
};
